import { render, staticRenderFns } from "./OrderCommentInputs.vue?vue&type=template&id=0ac67a0a&"
import script from "./OrderCommentInputs.vue?vue&type=script&lang=ts&"
export * from "./OrderCommentInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports